import {
  getCurrentPositionAsync,
  getLastKnownPositionAsync,
  requestForegroundPermissionsAsync,
} from "expo-location";
import { useCallback } from "react";
import { Alert, Linking } from "react-native";

type Props = {
  t: NotWorth;
};

export const useGetUserCoordinates = ({ t }: Props) => {
  const getUserCoordinates = useCallback(async () => {
    try {
      const { status } = await requestForegroundPermissionsAsync();
      if (status !== "granted") {
        setTimeout(() => {
          Alert.alert(
            t("alerts.locationNotEnabledTitle"),
            t("alerts.locationNotEnabledDescription"),
            [
              { onPress: () => {}, text: t("common.OK") },
              {
                onPress: Linking.openSettings,
                text: t("screens.settings.title"),
              },
            ],
          );
        }, 3000);
        return;
      }

      try {
        const lastKnownLocation = await getLastKnownPositionAsync({
          maxAge: 1000 * 60 * 30,
          requiredAccuracy: 1000,
        });
        const location = lastKnownLocation ?? (await getCurrentPositionAsync({}));

        return location.coords;
      } catch (_error) {
        return;
      }
    } catch (_error) {
      return;
    }
  }, [t]);

  return getUserCoordinates;
};
